import { ActionType } from "../types";
import { UserDelegates, UserDelegatesAction } from "../types/user_delegates";

export const user_delegates = (
  state: UserDelegates = null,
  action: UserDelegatesAction
): UserDelegates => {
  switch (action.type) {
    case ActionType.DELETE_USER_DELEGATE_SUCCESS:
      return state && action.success
        ? state.filter((delegate) => delegate.id !== action.id)
        : state;
    case ActionType.GET_USER_DELEGATES_REQUEST:
      return null;
    case ActionType.GET_USER_DELEGATES_SUCCESS:
      return action.delegates;
    case ActionType.GET_USER_DELEGATES_FAILURE:
      return null;
    case ActionType.CREATE_USER_DELEGATE_SUCCESS:
      return state ? state.concat(action.delegate) : state;
    case ActionType.UPDATE_USER_DELEGATE_SUCCESS:
      return state
        ? state.map((delegate) =>
            delegate.id === action.delegate.id ? action.delegate : delegate
          )
        : state;
    default:
      return state;
  }
};
